import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { FadeUp } from "./Motion";
import { FESTIVE } from "../../lib/catalog";
import { api, imgUrl } from "../../lib/api";

export const FestiveTile = () => {
  const { data } = useQuery({ queryKey: ["photos", FESTIVE.slug, 1], queryFn: () => api.get(`/categories/${FESTIVE.slug}/photos`).then((r) => r.data), retry: false });
  const items = Array.isArray(data?.items) ? data.items : [];
  if (!items.length) return null;
  return (
    <FadeUp className="mb-5">
      <Link to={`/c/${FESTIVE.slug}`} className="group relative grid overflow-hidden rounded-[26px] bg-[#240620] text-[#FFF8EF] md:grid-cols-12" data-testid="collection-tile-festive-offers">
        <div className="relative z-10 flex flex-col justify-center gap-3 p-6 sm:p-8 md:col-span-5">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-gold-foil px-3 py-1 text-xs font-semibold text-[#240620]"><Sparkles size={13} /> Festival special</span>
          <h3 className="font-display text-4xl leading-none sm:text-5xl">{FESTIVE.name}</h3>
          <p className="max-w-md text-sm text-[#E8D8C8] sm:text-base">{FESTIVE.desc}</p>
          <p className="font-cinzel text-[11px] tracking-[0.3em] text-[#D4AF37]">{data.total} designs · view offers →</p>
        </div>
        <div className="grid grid-cols-3 gap-2 p-3 sm:grid-cols-5 md:col-span-7">
          {items.slice(0, 5).map((p, i) => (
            <div key={p.id} className={`aspect-[3/4] overflow-hidden rounded-2xl ${i > 2 ? "hidden sm:block" : ""}`}>
              <img src={imgUrl(p.url)} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
            </div>
          ))}
        </div>
        <span className="absolute right-4 top-4 z-10 flex h-11 w-11 items-center justify-center rounded-full bg-[#FFF8EF]/10 backdrop-blur-md transition-[transform,background-color] duration-500 group-hover:rotate-45 group-hover:bg-[#D4AF37] group-hover:text-[#240620]">
          <ArrowUpRight size={20} />
        </span>
      </Link>
    </FadeUp>
  );
};
